export default "__VITE_ASSET__DQYC$dZx__"